// extracted by mini-css-extract-plugin
module.exports = {"demi-bold":"Header_demi-bold__vUFz_","header":"Header_header__Z8PUO","logo":"Header_logo__gECVj","fadeInAnimation":"Header_fadeInAnimation__obv_a"};